import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Country, EventItem, Lookups, Race} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {LocalizedDatePipe} from "@pipes";
import dayjs from "dayjs";
import {EVENT_DETAILS, PRIVATE_EVENT_CALENDAR_ROUTE} from "../../app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-my-upcoming-heading',
  templateUrl: './my-upcoming-heading.component.html',
  styleUrl: './my-upcoming-heading.component.scss'
})
export class MyUpcomingHeadingComponent {
  @Input() type: MyUpcomingHeadingType = MyUpcomingHeadingType.EVENT;
  @Input() event: EventItem | undefined = undefined;
  @Input() race: Race | undefined = undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];
  @Output() onClick = new EventEmitter<void>();
  @Input() cssClass: string | undefined;

  localizedDatePipe: LocalizedDatePipe;
  dateString: string = "";
  country: string | undefined;

  constructor(public translocoService: TranslocoService, private route: ActivatedRoute,
              private router: Router) {
    this.localizedDatePipe = new LocalizedDatePipe(translocoService);
  }

  ngOnInit() {
    this.formatDate();
    this.getCountryName(this.race?.startCountry ?? this.event?.country);
  }

  onHeadingClick() {
    this.onClick.emit()
  }

  formatDate() {
    const start = this.type === MyUpcomingHeadingType.RACE ? this.race?.raceStart : this.event?.start;
    const end = this.type === MyUpcomingHeadingType.RACE ? this.race?.raceEnd : this.event?.end;
    if (start && end) {
      if (this.type === MyUpcomingHeadingType.EVENT) {
        if (dayjs(start).isSame(dayjs(end), 'days')) {
          this.dateString = `${this.localizedDatePipe.transform(start)} - ${this.localizedDatePipe.transform(end, "HH:mm")}`
        } else {
          this.dateString = `${this.localizedDatePipe.transform(start)} - ${this.localizedDatePipe.transform(end)}`
        }
      }
      if (this.type === MyUpcomingHeadingType.RACE) {
        this.dateString = `${this.localizedDatePipe.transform(start, 'shortDate')}`
      }
    }
  }

  goToEventDetails(clickEvent: Event) {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();
    this.router.navigate([PRIVATE_EVENT_CALENDAR_ROUTE, EVENT_DETAILS], {
      queryParams: {eventId: this.event?.id}
    });
  }

  getCountryName(countryCode: number | undefined) {
    this.countries?.find((country: Country) => {
      if (countryCode === country.id) {
        this.country = country?.name;
      }
    });
  }

  protected readonly MyUpcomingHeadingType = MyUpcomingHeadingType;

}

export enum MyUpcomingHeadingType {
  RACE,
  EVENT
}
